import data from '../data.json'

const countryComparisonData = [
    {
        "text": "Select a country",
        "value": null
    },
    {
        "text": "Albania",
        "value": {
            "label": "Albania",
            "data": [
                data.albania.future_readiness_score,
                data.albania.physical_capital,
                data.albania.human_capital,
                data.albania.technology,
                data.albania.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Algeria",
        "value": {
            "label": "Algeria",
            "data": [
                data.algeria.future_readiness_score,
                data.algeria.physical_capital,
                data.algeria.human_capital,
                data.algeria.technology,
                data.algeria.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Angola",
        "value": {
            "label": "Angola",
            "data": [
                data.angola.future_readiness_score,
                data.angola.physical_capital,
                data.angola.human_capital,
                data.angola.technology,
                data.angola.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Argentina",
        "value": {
            "label": "Argentina",
            "data": [
                data.argentina.future_readiness_score,
                data.argentina.physical_capital,
                data.argentina.human_capital,
                data.argentina.technology,
                data.argentina.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Armenia",
        "value": {
            "label": "Armenia",
            "data": [
                data.armenia.future_readiness_score,
                data.armenia.physical_capital,
                data.armenia.human_capital,
                data.armenia.technology,
                data.armenia.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Australia",
        "value": {
            "label": "Australia",
            "data": [
                data.australia.future_readiness_score,
                data.australia.physical_capital,
                data.australia.human_capital,
                data.australia.technology,
                data.australia.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Austria",
        "value": {
            "label": "Austria",
            "data": [
                data.austria.future_readiness_score,
                data.austria.physical_capital,
                data.austria.human_capital,
                data.austria.technology,
                data.austria.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Azerbaijan",
        "value": {
            "label": "Azerbaijan",
            "data": [
                data.azerbaijan.future_readiness_score,
                data.azerbaijan.physical_capital,
                data.azerbaijan.human_capital,
                data.azerbaijan.technology,
                data.azerbaijan.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Bahrain",
        "value": {
            "label": "Bahrain",
            "data": [
                data.bahrain.future_readiness_score,
                data.bahrain.physical_capital,
                data.bahrain.human_capital,
                data.bahrain.technology,
                data.bahrain.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Bangladesh",
        "value": {
            "label": "Bangladesh",
            "data": [
                data.bangladesh.future_readiness_score,
                data.bangladesh.physical_capital,
                data.bangladesh.human_capital,
                data.bangladesh.technology,
                data.bangladesh.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Belarus",
        "value": {
            "label": "Belarus",
            "data": [
                data.belarus.future_readiness_score,
                data.belarus.physical_capital,
                data.belarus.human_capital,
                data.belarus.technology,
                data.belarus.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Belgium",
        "value": {
            "label": "Belgium",
            "data": [
                data.belgium.future_readiness_score,
                data.belgium.physical_capital,
                data.belgium.human_capital,
                data.belgium.technology,
                data.belgium.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Benin",
        "value": {
            "label": "Benin",
            "data": [
                data.benin.future_readiness_score,
                data.benin.physical_capital,
                data.benin.human_capital,
                data.benin.technology,
                data.benin.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Bolivia",
        "value": {
            "label": "Bolivia",
            "data": [
                data.bolivia.future_readiness_score,
                data.bolivia.physical_capital,
                data.bolivia.human_capital,
                data.bolivia.technology,
                data.bolivia.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Bosnia and Herzegovina",
        "value": {
            "label": "Bosnia and Herzegovina",
            "data": [
                data.bosnia_and_herzegovina.future_readiness_score,
                data.bosnia_and_herzegovina.physical_capital,
                data.bosnia_and_herzegovina.human_capital,
                data.bosnia_and_herzegovina.technology,
                data.bosnia_and_herzegovina.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Botswana",
        "value": {
            "label": "Botswana",
            "data": [
                data.botswana.future_readiness_score,
                data.botswana.physical_capital,
                data.botswana.human_capital,
                data.botswana.technology,
                data.botswana.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Brazil",
        "value": {
            "label": "Brazil",
            "data": [
                data.brazil.future_readiness_score,
                data.brazil.physical_capital,
                data.brazil.human_capital,
                data.brazil.technology,
                data.brazil.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Bulgaria",
        "value": {
            "label": "Bulgaria",
            "data": [
                data.bulgaria.future_readiness_score,
                data.bulgaria.physical_capital,
                data.bulgaria.human_capital,
                data.bulgaria.technology,
                data.bulgaria.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Burkina Faso",
        "value": {
            "label": "Burkina Faso",
            "data": [
                data.burkina_faso.future_readiness_score,
                data.burkina_faso.physical_capital,
                data.burkina_faso.human_capital,
                data.burkina_faso.technology,
                data.burkina_faso.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Cambodia",
        "value": {
            "label": "Cambodia",
            "data": [
                data.cambodia.future_readiness_score,
                data.cambodia.physical_capital,
                data.cambodia.human_capital,
                data.cambodia.technology,
                data.cambodia.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Cameroon",
        "value": {
            "label": "Cameroon",
            "data": [
                data.cameroon.future_readiness_score,
                data.cameroon.physical_capital,
                data.cameroon.human_capital,
                data.cameroon.technology,
                data.cameroon.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Canada",
        "value": {
            "label": "Canada",
            "data": [
                data.canada.future_readiness_score,
                data.canada.physical_capital,
                data.canada.human_capital,
                data.canada.technology,
                data.canada.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Chile",
        "value": {
            "label": "Chile",
            "data": [
                data.chile.future_readiness_score,
                data.chile.physical_capital,
                data.chile.human_capital,
                data.chile.technology,
                data.chile.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "China",
        "value": {
            "label": "China",
            "data": [
                data.china.future_readiness_score,
                data.china.physical_capital,
                data.china.human_capital,
                data.china.technology,
                data.china.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Colombia",
        "value": {
            "label": "Colombia",
            "data": [
                data.colombia.future_readiness_score,
                data.colombia.physical_capital,
                data.colombia.human_capital,
                data.colombia.technology,
                data.colombia.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Costa Rica",
        "value": {
            "label": "Costa Rica",
            "data": [
                data.costa_rica.future_readiness_score,
                data.costa_rica.physical_capital,
                data.costa_rica.human_capital,
                data.costa_rica.technology,
                data.costa_rica.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Côte d'Ivoire",
        "value": {
            "label": "Côte d'Ivoire",
            "data": [
                data.cote_divoire.future_readiness_score,
                data.cote_divoire.physical_capital,
                data.cote_divoire.human_capital,
                data.cote_divoire.technology,
                data.cote_divoire.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Croatia",
        "value": {
            "label": "Croatia",
            "data": [
                data.croatia.future_readiness_score,
                data.croatia.physical_capital,
                data.croatia.human_capital,
                data.croatia.technology,
                data.croatia.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Cyprus",
        "value": {
            "label": "Cyprus",
            "data": [
                data.cyprus.future_readiness_score,
                data.cyprus.physical_capital,
                data.cyprus.human_capital,
                data.cyprus.technology,
                data.cyprus.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Czech Republic",
        "value": {
            "label": "Czech Republic",
            "data": [
                data.czech_republic.future_readiness_score,
                data.czech_republic.physical_capital,
                data.czech_republic.human_capital,
                data.czech_republic.technology,
                data.czech_republic.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Denmark",
        "value": {
            "label": "Denmark",
            "data": [
                data.denmark.future_readiness_score,
                data.denmark.physical_capital,
                data.denmark.human_capital,
                data.denmark.technology,
                data.denmark.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Dominican Republic",
        "value": {
            "label": "Dominican Republic",
            "data": [
                data.dominican_republic.future_readiness_score,
                data.dominican_republic.physical_capital,
                data.dominican_republic.human_capital,
                data.dominican_republic.technology,
                data.dominican_republic.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Ecuador",
        "value": {
            "label": "Ecuador",
            "data": [
                data.ecuador.future_readiness_score,
                data.ecuador.physical_capital,
                data.ecuador.human_capital,
                data.ecuador.technology,
                data.ecuador.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Egypt",
        "value": {
            "label": "Egypt",
            "data": [
                data.egypt.future_readiness_score,
                data.egypt.physical_capital,
                data.egypt.human_capital,
                data.egypt.technology,
                data.egypt.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "El Salvador",
        "value": {
            "label": "El Salvador",
            "data": [
                data.el_salvador.future_readiness_score,
                data.el_salvador.physical_capital,
                data.el_salvador.human_capital,
                data.el_salvador.technology,
                data.el_salvador.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Estonia",
        "value": {
            "label": "Estonia",
            "data": [
                data.estonia.future_readiness_score,
                data.estonia.physical_capital,
                data.estonia.human_capital,
                data.estonia.technology,
                data.estonia.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Ethiopia",
        "value": {
            "label": "Ethiopia",
            "data": [
                data.ethiopia.future_readiness_score,
                data.ethiopia.physical_capital,
                data.ethiopia.human_capital,
                data.ethiopia.technology,
                data.ethiopia.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Finland",
        "value": {
            "label": "Finland",
            "data": [
                data.finland.future_readiness_score,
                data.finland.physical_capital,
                data.finland.human_capital,
                data.finland.technology,
                data.finland.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "France",
        "value": {
            "label": "France",
            "data": [
                data.france.future_readiness_score,
                data.france.physical_capital,
                data.france.human_capital,
                data.france.technology,
                data.france.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Georgia",
        "value": {
            "label": "Georgia",
            "data": [
                data.georgia.future_readiness_score,
                data.georgia.physical_capital,
                data.georgia.human_capital,
                data.georgia.technology,
                data.georgia.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Germany",
        "value": {
            "label": "Germany",
            "data": [
                data.germany.future_readiness_score,
                data.germany.physical_capital,
                data.germany.human_capital,
                data.germany.technology,
                data.germany.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Ghana",
        "value": {
            "label": "Ghana",
            "data": [
                data.ghana.future_readiness_score,
                data.ghana.physical_capital,
                data.ghana.human_capital,
                data.ghana.technology,
                data.ghana.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Greece",
        "value": {
            "label": "Greece",
            "data": [
                data.greece.future_readiness_score,
                data.greece.physical_capital,
                data.greece.human_capital,
                data.greece.technology,
                data.greece.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Guatemala",
        "value": {
            "label": "Guatemala",
            "data": [
                data.guatemala.future_readiness_score,
                data.guatemala.physical_capital,
                data.guatemala.human_capital,
                data.guatemala.technology,
                data.guatemala.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Guinea",
        "value": {
            "label": "Guinea",
            "data": [
                data.guinea.future_readiness_score,
                data.guinea.physical_capital,
                data.guinea.human_capital,
                data.guinea.technology,
                data.guinea.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Honduras",
        "value": {
            "label": "Honduras",
            "data": [
                data.honduras.future_readiness_score,
                data.honduras.physical_capital,
                data.honduras.human_capital,
                data.honduras.technology,
                data.honduras.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Hungary",
        "value": {
            "label": "Hungary",
            "data": [
                data.hungary.future_readiness_score,
                data.hungary.physical_capital,
                data.hungary.human_capital,
                data.hungary.technology,
                data.hungary.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Iceland",
        "value": {
            "label": "Iceland",
            "data": [
                data.iceland.future_readiness_score,
                data.iceland.physical_capital,
                data.iceland.human_capital,
                data.iceland.technology,
                data.iceland.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "India",
        "value": {
            "label": "India",
            "data": [
                data.india.future_readiness_score,
                data.india.physical_capital,
                data.india.human_capital,
                data.india.technology,
                data.india.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Indonesia",
        "value": {
            "label": "Indonesia",
            "data": [
                data.indonesia.future_readiness_score,
                data.indonesia.physical_capital,
                data.indonesia.human_capital,
                data.indonesia.technology,
                data.indonesia.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Iran",
        "value": {
            "label": "Iran",
            "data": [
                data.iran.future_readiness_score,
                data.iran.physical_capital,
                data.iran.human_capital,
                data.iran.technology,
                data.iran.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Ireland",
        "value": {
            "label": "Ireland",
            "data": [
                data.ireland.future_readiness_score,
                data.ireland.physical_capital,
                data.ireland.human_capital,
                data.ireland.technology,
                data.ireland.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Israel",
        "value": {
            "label": "Israel",
            "data": [
                data.israel.future_readiness_score,
                data.israel.physical_capital,
                data.israel.human_capital,
                data.israel.technology,
                data.israel.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Italy",
        "value": {
            "label": "Italy",
            "data": [
                data.italy.future_readiness_score,
                data.italy.physical_capital,
                data.italy.human_capital,
                data.italy.technology,
                data.italy.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Jamaica",
        "value": {
            "label": "Jamaica",
            "data": [
                data.jamaica.future_readiness_score,
                data.jamaica.physical_capital,
                data.jamaica.human_capital,
                data.jamaica.technology,
                data.jamaica.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Japan",
        "value": {
            "label": "Japan",
            "data": [
                data.japan.future_readiness_score,
                data.japan.physical_capital,
                data.japan.human_capital,
                data.japan.technology,
                data.japan.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Jordan",
        "value": {
            "label": "Jordan",
            "data": [
                data.jordan.future_readiness_score,
                data.jordan.physical_capital,
                data.jordan.human_capital,
                data.jordan.technology,
                data.jordan.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Kazakhstan",
        "value": {
            "label": "Kazakhstan",
            "data": [
                data.kazakhstan.future_readiness_score,
                data.kazakhstan.physical_capital,
                data.kazakhstan.human_capital,
                data.kazakhstan.technology,
                data.kazakhstan.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Kenya",
        "value": {
            "label": "Kenya",
            "data": [
                data.kenya.future_readiness_score,
                data.kenya.physical_capital,
                data.kenya.human_capital,
                data.kenya.technology,
                data.kenya.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Kuwait",
        "value": {
            "label": "Kuwait",
            "data": [
                data.kuwait.future_readiness_score,
                data.kuwait.physical_capital,
                data.kuwait.human_capital,
                data.kuwait.technology,
                data.kuwait.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Kyrgyzstan",
        "value": {
            "label": "Kyrgyzstan",
            "data": [
                data.kyrgyzstan.future_readiness_score,
                data.kyrgyzstan.physical_capital,
                data.kyrgyzstan.human_capital,
                data.kyrgyzstan.technology,
                data.kyrgyzstan.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Laos",
        "value": {
            "label": "Laos",
            "data": [
                data.laos.future_readiness_score,
                data.laos.physical_capital,
                data.laos.human_capital,
                data.laos.technology,
                data.laos.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Latvia",
        "value": {
            "label": "Latvia",
            "data": [
                data.latvia.future_readiness_score,
                data.latvia.physical_capital,
                data.latvia.human_capital,
                data.latvia.technology,
                data.latvia.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Lebanon",
        "value": {
            "label": "Lebanon",
            "data": [
                data.lebanon.future_readiness_score,
                data.lebanon.physical_capital,
                data.lebanon.human_capital,
                data.lebanon.technology,
                data.lebanon.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Lithuania",
        "value": {
            "label": "Lithuania",
            "data": [
                data.lithuania.future_readiness_score,
                data.lithuania.physical_capital,
                data.lithuania.human_capital,
                data.lithuania.technology,
                data.lithuania.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Luxembourg",
        "value": {
            "label": "Luxembourg",
            "data": [
                data.luxembourg.future_readiness_score,
                data.luxembourg.physical_capital,
                data.luxembourg.human_capital,
                data.luxembourg.technology,
                data.luxembourg.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Madagascar",
        "value": {
            "label": "Madagascar",
            "data": [
                data.madagascar.future_readiness_score,
                data.madagascar.physical_capital,
                data.madagascar.human_capital,
                data.madagascar.technology,
                data.madagascar.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Malawi",
        "value": {
            "label": "Malawi",
            "data": [
                data.malawi.future_readiness_score,
                data.malawi.physical_capital,
                data.malawi.human_capital,
                data.malawi.technology,
                data.malawi.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Malaysia",
        "value": {
            "label": "Malaysia",
            "data": [
                data.malaysia.future_readiness_score,
                data.malaysia.physical_capital,
                data.malaysia.human_capital,
                data.malaysia.technology,
                data.malaysia.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Mali",
        "value": {
            "label": "Mali",
            "data": [
                data.mali.future_readiness_score,
                data.mali.physical_capital,
                data.mali.human_capital,
                data.mali.technology,
                data.mali.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Malta",
        "value": {
            "label": "Malta",
            "data": [
                data.malta.future_readiness_score,
                data.malta.physical_capital,
                data.malta.human_capital,
                data.malta.technology,
                data.malta.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Mauritius",
        "value": {
            "label": "Mauritius",
            "data": [
                data.mauritius.future_readiness_score,
                data.mauritius.physical_capital,
                data.mauritius.human_capital,
                data.mauritius.technology,
                data.mauritius.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Mexico",
        "value": {
            "label": "Mexico",
            "data": [
                data.mexico.future_readiness_score,
                data.mexico.physical_capital,
                data.mexico.human_capital,
                data.mexico.technology,
                data.mexico.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Moldova",
        "value": {
            "label": "Moldova",
            "data": [
                data.moldova.future_readiness_score,
                data.moldova.physical_capital,
                data.moldova.human_capital,
                data.moldova.technology,
                data.moldova.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Mongolia",
        "value": {
            "label": "Mongolia",
            "data": [
                data.mongolia.future_readiness_score,
                data.mongolia.physical_capital,
                data.mongolia.human_capital,
                data.mongolia.technology,
                data.mongolia.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Morocco",
        "value": {
            "label": "Morocco",
            "data": [
                data.morocco.future_readiness_score,
                data.morocco.physical_capital,
                data.morocco.human_capital,
                data.morocco.technology,
                data.morocco.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Mozambique",
        "value": {
            "label": "Mozambique",
            "data": [
                data.mozambique.future_readiness_score,
                data.mozambique.physical_capital,
                data.mozambique.human_capital,
                data.mozambique.technology,
                data.mozambique.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Myanmar",
        "value": {
            "label": "Myanmar",
            "data": [
                data.myanmar.future_readiness_score,
                data.myanmar.physical_capital,
                data.myanmar.human_capital,
                data.myanmar.technology,
                data.myanmar.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Nepal",
        "value": {
            "label": "Nepal",
            "data": [
                data.nepal.future_readiness_score,
                data.nepal.physical_capital,
                data.nepal.human_capital,
                data.nepal.technology,
                data.nepal.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Netherlands",
        "value": {
            "label": "Netherlands",
            "data": [
                data.netherlands.future_readiness_score,
                data.netherlands.physical_capital,
                data.netherlands.human_capital,
                data.netherlands.technology,
                data.netherlands.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "New Zealand",
        "value": {
            "label": "New Zealand",
            "data": [
                data.new_zealand.future_readiness_score,
                data.new_zealand.physical_capital,
                data.new_zealand.human_capital,
                data.new_zealand.technology,
                data.new_zealand.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Niger",
        "value": {
            "label": "Niger",
            "data": [
                data.niger.future_readiness_score,
                data.niger.physical_capital,
                data.niger.human_capital,
                data.niger.technology,
                data.niger.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Nigeria",
        "value": {
            "label": "Nigeria",
            "data": [
                data.nigeria.future_readiness_score,
                data.nigeria.physical_capital,
                data.nigeria.human_capital,
                data.nigeria.technology,
                data.nigeria.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "North Macedonia",
        "value": {
            "label": "North Macedonia",
            "data": [
                data.north_macedonia.future_readiness_score,
                data.north_macedonia.physical_capital,
                data.north_macedonia.human_capital,
                data.north_macedonia.technology,
                data.north_macedonia.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Norway",
        "value": {
            "label": "Norway",
            "data": [
                data.norway.future_readiness_score,
                data.norway.physical_capital,
                data.norway.human_capital,
                data.norway.technology,
                data.norway.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Oman",
        "value": {
            "label": "Oman",
            "data": [
                data.oman.future_readiness_score,
                data.oman.physical_capital,
                data.oman.human_capital,
                data.oman.technology,
                data.oman.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Pakistan",
        "value": {
            "label": "Pakistan",
            "data": [
                data.pakistan.future_readiness_score,
                data.pakistan.physical_capital,
                data.pakistan.human_capital,
                data.pakistan.technology,
                data.pakistan.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Panama",
        "value": {
            "label": "Panama",
            "data": [
                data.panama.future_readiness_score,
                data.panama.physical_capital,
                data.panama.human_capital,
                data.panama.technology,
                data.panama.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Paraguay",
        "value": {
            "label": "Paraguay",
            "data": [
                data.paraguay.future_readiness_score,
                data.paraguay.physical_capital,
                data.paraguay.human_capital,
                data.paraguay.technology,
                data.paraguay.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Peru",
        "value": {
            "label": "Peru",
            "data": [
                data.peru.future_readiness_score,
                data.peru.physical_capital,
                data.peru.human_capital,
                data.peru.technology,
                data.peru.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Philippines",
        "value": {
            "label": "Philippines",
            "data": [
                data.philippines.future_readiness_score,
                data.philippines.physical_capital,
                data.philippines.human_capital,
                data.philippines.technology,
                data.philippines.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Poland",
        "value": {
            "label": "Poland",
            "data": [
                data.poland.future_readiness_score,
                data.poland.physical_capital,
                data.poland.human_capital,
                data.poland.technology,
                data.poland.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Portugal",
        "value": {
            "label": "Portugal",
            "data": [
                data.portugal.future_readiness_score,
                data.portugal.physical_capital,
                data.portugal.human_capital,
                data.portugal.technology,
                data.portugal.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Qatar",
        "value": {
            "label": "Qatar",
            "data": [
                data.qatar.future_readiness_score,
                data.qatar.physical_capital,
                data.qatar.human_capital,
                data.qatar.technology,
                data.qatar.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Romania",
        "value": {
            "label": "Romania",
            "data": [
                data.romania.future_readiness_score,
                data.romania.physical_capital,
                data.romania.human_capital,
                data.romania.technology,
                data.romania.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Russia",
        "value": {
            "label": "Russia",
            "data": [
                data.russia.future_readiness_score,
                data.russia.physical_capital,
                data.russia.human_capital,
                data.russia.technology,
                data.russia.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Rwanda",
        "value": {
            "label": "Rwanda",
            "data": [
                data.rwanda.future_readiness_score,
                data.rwanda.physical_capital,
                data.rwanda.human_capital,
                data.rwanda.technology,
                data.rwanda.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Saudi Arabia",
        "value": {
            "label": "Saudi Arabia",
            "data": [
                data.saudi_arabia.future_readiness_score,
                data.saudi_arabia.physical_capital,
                data.saudi_arabia.human_capital,
                data.saudi_arabia.technology,
                data.saudi_arabia.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Senegal",
        "value": {
            "label": "Senegal",
            "data": [
                data.senegal.future_readiness_score,
                data.senegal.physical_capital,
                data.senegal.human_capital,
                data.senegal.technology,
                data.senegal.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Serbia",
        "value": {
            "label": "Serbia",
            "data": [
                data.serbia.future_readiness_score,
                data.serbia.physical_capital,
                data.serbia.human_capital,
                data.serbia.technology,
                data.serbia.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Singapore",
        "value": {
            "label": "Singapore",
            "data": [
                data.singapore.future_readiness_score,
                data.singapore.physical_capital,
                data.singapore.human_capital,
                data.singapore.technology,
                data.singapore.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Slovakia",
        "value": {
            "label": "Slovakia",
            "data": [
                data.slovakia.future_readiness_score,
                data.slovakia.physical_capital,
                data.slovakia.human_capital,
                data.slovakia.technology,
                data.slovakia.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Slovenia",
        "value": {
            "label": "Slovenia",
            "data": [
                data.slovenia.future_readiness_score,
                data.slovenia.physical_capital,
                data.slovenia.human_capital,
                data.slovenia.technology,
                data.slovenia.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "South Africa",
        "value": {
            "label": "South Africa",
            "data": [
                data.south_africa.future_readiness_score,
                data.south_africa.physical_capital,
                data.south_africa.human_capital,
                data.south_africa.technology,
                data.south_africa.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "South Korea",
        "value": {
            "label": "South Korea",
            "data": [
                data.south_korea.future_readiness_score,
                data.south_korea.physical_capital,
                data.south_korea.human_capital,
                data.south_korea.technology,
                data.south_korea.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Spain",
        "value": {
            "label": "Spain",
            "data": [
                data.spain.future_readiness_score,
                data.spain.physical_capital,
                data.spain.human_capital,
                data.spain.technology,
                data.spain.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Sri Lanka",
        "value": {
            "label": "Sri Lanka",
            "data": [
                data.sri_lanka.future_readiness_score,
                data.sri_lanka.physical_capital,
                data.sri_lanka.human_capital,
                data.sri_lanka.technology,
                data.sri_lanka.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Sweden",
        "value": {
            "label": "Sweden",
            "data": [
                data.sweden.future_readiness_score,
                data.sweden.physical_capital,
                data.sweden.human_capital,
                data.sweden.technology,
                data.sweden.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Switzerland",
        "value": {
            "label": "Switzerland",
            "data": [
                data.switzerland.future_readiness_score,
                data.switzerland.physical_capital,
                data.switzerland.human_capital,
                data.switzerland.technology,
                data.switzerland.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Tanzania",
        "value": {
            "label": "Tanzania",
            "data": [
                data.tanzania.future_readiness_score,
                data.tanzania.physical_capital,
                data.tanzania.human_capital,
                data.tanzania.technology,
                data.tanzania.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Thailand",
        "value": {
            "label": "Thailand",
            "data": [
                data.thailand.future_readiness_score,
                data.thailand.physical_capital,
                data.thailand.human_capital,
                data.thailand.technology,
                data.thailand.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Togo",
        "value": {
            "label": "Togo",
            "data": [
                data.togo.future_readiness_score,
                data.togo.physical_capital,
                data.togo.human_capital,
                data.togo.technology,
                data.togo.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Trinidad and Tobago",
        "value": {
            "label": "Trinidad and Tobago",
            "data": [
                data.trinidad_and_tobago.future_readiness_score,
                data.trinidad_and_tobago.physical_capital,
                data.trinidad_and_tobago.human_capital,
                data.trinidad_and_tobago.technology,
                data.trinidad_and_tobago.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Tunisia",
        "value": {
            "label": "Tunisia",
            "data": [
                data.tunisia.future_readiness_score,
                data.tunisia.physical_capital,
                data.tunisia.human_capital,
                data.tunisia.technology,
                data.tunisia.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Turkey",
        "value": {
            "label": "Turkey",
            "data": [
                data.turkey.future_readiness_score,
                data.turkey.physical_capital,
                data.turkey.human_capital,
                data.turkey.technology,
                data.turkey.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Uganda",
        "value": {
            "label": "Uganda",
            "data": [
                data.uganda.future_readiness_score,
                data.uganda.physical_capital,
                data.uganda.human_capital,
                data.uganda.technology,
                data.uganda.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Ukraine",
        "value": {
            "label": "Ukraine",
            "data": [
                data.ukraine.future_readiness_score,
                data.ukraine.physical_capital,
                data.ukraine.human_capital,
                data.ukraine.technology,
                data.ukraine.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "United Arab Emirates",
        "value": {
            "label": "United Arab Emirates",
            "data": [
                data.united_arab_emirates.future_readiness_score,
                data.united_arab_emirates.physical_capital,
                data.united_arab_emirates.human_capital,
                data.united_arab_emirates.technology,
                data.united_arab_emirates.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "United Kingdom",
        "value": {
            "label": "United Kingdom",
            "data": [
                data.united_kingdom.future_readiness_score,
                data.united_kingdom.physical_capital,
                data.united_kingdom.human_capital,
                data.united_kingdom.technology,
                data.united_kingdom.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "United States",
        "value": {
            "label": "United States",
            "data": [
                data.united_states.future_readiness_score,
                data.united_states.physical_capital,
                data.united_states.human_capital,
                data.united_states.technology,
                data.united_states.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Uruguay",
        "value": {
            "label": "Uruguay",
            "data": [
                data.uruguay.future_readiness_score,
                data.uruguay.physical_capital,
                data.uruguay.human_capital,
                data.uruguay.technology,
                data.uruguay.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Vietnam",
        "value": {
            "label": "Vietnam",
            "data": [
                data.vietnam.future_readiness_score,
                data.vietnam.physical_capital,
                data.vietnam.human_capital,
                data.vietnam.technology,
                data.vietnam.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Zambia",
        "value": {
            "label": "Zambia",
            "data": [
                data.zambia.future_readiness_score,
                data.zambia.physical_capital,
                data.zambia.human_capital,
                data.zambia.technology,
                data.zambia.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    },
    {
        "text": "Zimbabwe",
        "value": {
            "label": "Zimbabwe",
            "data": [
                data.zimbabwe.future_readiness_score,
                data.zimbabwe.physical_capital,
                data.zimbabwe.human_capital,
                data.zimbabwe.technology,
                data.zimbabwe.competitiveness,
            ],
            "fill": true,
            "lineTension": 0.2,
            "borderColor": "#88D8B0",
            "backgroundColor": "#FFFFFF00",
            "borderWidth": 3
        }
    }
]

export default countryComparisonData
